import { round } from "@repo/system";
import type { StepVariant } from "@repo/types";

type CalculateVariantTotalArgs = {
  variants: StepVariant[];
  showPricesInclVat: boolean;
};

/**
 * Calculates the total price of selected variant choices.
 *
 * Prices are pre-calculated with the correct VAT at variant selection time,
 * so we use unitPriceWithVat and unitPrice directly without recalculating.
 */
export const calculateVariantTotal = ({
  variants,
  showPricesInclVat
}: CalculateVariantTotalArgs) => {
  return variants.reduce((sum, variant) => {
    const choicesSum = variant.choices.reduce((sum, choice) => {
      // Use pre-calculated prices directly
      const unitPriceInclVat = choice.unitPriceWithVat ?? 0;
      const unitPriceExclVat = round(choice.unitPrice ?? 0, 2);

      const choiceTotal =
        choice.amount *
        (showPricesInclVat ? unitPriceInclVat : unitPriceExclVat);
      return sum + choiceTotal;
    }, 0);

    return sum + choicesSum;
  }, 0);
};
